import { useCallback } from 'react';

import AppLogger from 'utils/AppLogger';

const useSauidiQR = () => {
	const hexToBase64 = (hexstring) =>
		btoa(
			hexstring
				.match(/\w{2}/g)
				.map((a) => String.fromCharCode(parseInt(a, 16)))
				.join('')
		);

	const asciiToHex = (str) => {
		const arr1 = [];
		for (let n = 0, l = str.length; n < l; n += 1) {
			const hex = Number(str.charCodeAt(n)).toString(16);
			arr1.push(hex);
		}
		return arr1.join('');
	};

	const convertTohex = (arr) => {
		let allHex = '';
		for (let index = 0; index < arr.length; index += 1) {
			let myHex;
			const element = arr[index];
			// Tag
			const myIndex = index + 1;
			myHex = `0${myIndex.toString(16)}`;
			// Length
			if (element.length.toString(16).length > 1) {
				myHex += element.length.toString(16);
			} else {
				myHex += `0${element.length.toString(16)}`;
			}
			// Value
			myHex += asciiToHex(element);
			allHex += myHex;
		}

		return allHex;
	};

	const generateQRDataArr = useCallback((order, clientData) => {
		if (!clientData) return AppLogger.error('generateQRDataArr : clientData not found');
		if (!order) return AppLogger.error('generateQRDataArr : order data not found');

		const {
			// Saudi VAT number is 15 digits. use 0 as prefix to make it 15 digits
			ClientName = '',
			VATNumber = '000000000000000'
		} = clientData;

		const { qrDate = '', grandTotal = '0', taxAmount = '0' } = order;

		const arr = [ClientName, VATNumber, qrDate, String(grandTotal), String(taxAmount)];

		return arr;
	}, []);

	const generateBase64String = (order, clientData) => {
		if (Object.keys(order).length === 0) {
			AppLogger.error('generateBase64String : No text to generate QR code');
			throw new Error('generateBase64String : No text to generate QR code');
		}

		const resultHex = convertTohex(generateQRDataArr(order, clientData));
		const base64String = hexToBase64(resultHex);
		return base64String;
	};

	return { generateBase64String };
};

export default useSauidiQR;
